// frontend/src/askos/BookmarkButton.js
//
// Small reusable save/unsave toggle, wired into AskosChat, CurrentAffairsCard/
// Page, PyqPracticePage and ContentReaderPage. `target` must be an object
// with exactly one of the StudentBookmark FK keys set (teaching_material_id,
// content_block_id, concept_id, current_affairs_item_id, pyq_question_id).
import React, { useState } from 'react';
import { createBookmark, deleteBookmark } from '../api/bookmarksApi';

const BookmarkButton = ({ slug, target, note, className = '' }) => {
    const [bookmarkId, setBookmarkId] = useState(null);
    const [busy, setBusy] = useState(false);

    const toggle = async () => {
        if (busy) return;
        setBusy(true);
        try {
            if (bookmarkId) {
                await deleteBookmark(slug, bookmarkId);
                setBookmarkId(null);
            } else {
                const saved = await createBookmark(slug, { ...target, note });
                setBookmarkId(saved.id);
            }
        } catch {
            // best-effort — leave state unchanged on failure
        } finally {
            setBusy(false);
        }
    };

    return (
        <button
            type="button"
            className={`bookmark-btn ${bookmarkId ? 'saved' : ''} ${className}`}
            onClick={toggle}
            disabled={busy}
            title={bookmarkId ? 'Remove from Saved Resources' : 'Save for later'}
            aria-pressed={!!bookmarkId}
        >
            {bookmarkId ? '★ Saved' : '☆ Save'}
        </button>
    );
};

export default BookmarkButton;
